export interface IWizardStep<T> {
  route: string;
  questionId: string;
  config: T;
}
export interface IAnswerMap<Answer> {
  [key: string]: Answer;
}

export interface IWizardStepState<Step, Answer> {
  steps: IWizardStep<Step>[];
  currentStep: IWizardStep<Step> | null;
  answers: IAnswerMap<Answer>;
}
export class WizardManager<Step, Answer> {
  public static getIndexOfCurrentStep<Step, Answer>(
    wizardState: IWizardStepState<Step, Answer>,
  ) {
    const { currentStep, steps } = wizardState;
    if (!currentStep) {
      return null;
    }
    const indexOfCurrentStep = steps.findIndex(
      (step) => step.route === currentStep.route,
    );
    if (indexOfCurrentStep < 0) {
      return null;
    }
    return indexOfCurrentStep;
  }
  public getNextStep(
    wizardState: IWizardStepState<Step, Answer>,
  ) {
    const { steps } = wizardState;
    const indexOfCurrentStep = WizardManager.getIndexOfCurrentStep(wizardState);
    if (!indexOfCurrentStep && typeof indexOfCurrentStep !== 'number') {
      return null;
    }
    const nextIndex = (indexOfCurrentStep + 1) % steps.length;
    return steps[nextIndex];
  }

  public getPreviousStep(
    wizardState: IWizardStepState<Step, Answer>,
  ) {
    const { steps } = wizardState;
    const indexOfCurrentStep = WizardManager.getIndexOfCurrentStep(wizardState);
    if (!indexOfCurrentStep) {
      return null;
    }
    const isFirstStep = indexOfCurrentStep === 0;
    if (isFirstStep) {
      return null;
    }
    const previouIndex = indexOfCurrentStep - 1;
    return steps[previouIndex];
  }

  public getNextStepIndex(
    wizardState: IWizardStepState<Step, Answer>,
  ) {
    const indexOfCurrentStep = WizardManager.getIndexOfCurrentStep(wizardState);
    if (!indexOfCurrentStep) {
      return null;
    }
    const isLastStep = indexOfCurrentStep === wizardState.steps.length - 1;
    if (isLastStep) {
      return null;
    }
    return indexOfCurrentStep + 1;
  }

  public answer(wizardState: IWizardStepState<Step, Answer>, answer: Answer) {
    const { answers, currentStep } = wizardState;
    const { questionId } = currentStep!;
    answers[questionId] = answer;
    return answers;
  }
}
